import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FiArrowUp } from "react-icons/fi";

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    let ticking = false;

    const update = () => {
      ticking = false;
      const nextVisible = window.scrollY > 500;
      setIsVisible((prev) => (prev === nextVisible ? prev : nextVisible));
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    update();

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (pathname !== "/" || !isVisible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-8 right-8 z-50 p-1 bg-[#7D192A] text-white rounded-full shadow-2xl hover:bg-[#F4B400] transition-all duration-300 animate-bounce"
      aria-label="Back to top"
    >
      <FiArrowUp size={32} />
      <span className="sr-only">Back to top</span>
    </button>
  );
};

export default BackToTop;
